var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptopIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139.89,
    height: 95.829,
    viewBox: "0 0 139.89 95.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "laptop-ic",
    transform: "translate(-3078 3090.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M3078-3000.926v-1.64a10.191,10.191,0,0,0,.965-.9c3.651-4.366,7.269-8.76,10.95-13.1a4.211,4.211,0,0,0,1.04-2.955q-.042-32.174-.015-64.349a14.266,14.266,0,0,1,.15-2.312,5,5,0,0,1,4.47-4.131c.588-.054,1.182-.058,1.773-.058q50.609,0,101.217,0c.591,0,1.186,0,1.773.057a5.005,5.005,0,0,1,4.487,4.271,16.554,16.554,0,0,1,.126,2.314q.01,32.243.042,64.485a4.166,4.166,0,0,0,.866,2.429c3.673,4.524,7.428,8.981,11.167,13.451a8.268,8.268,0,0,0,.877.794v1.64c-.249.625-.456,1.272-.755,1.873-1.653,3.32-4.436,4.516-8.036,4.513q-61.152-.047-122.3-.022c-.545,0-1.092-.019-1.636-.056a7.354,7.354,0,0,1-5.944-3.594A19.525,19.525,0,0,1,3078-3000.926Zm69.967-21.575q22.127,0,44.253,0c3.745,0,5.43-1.675,5.431-5.4q.006-26.161.005-52.322c0-3.835-1.649-5.494-5.48-5.494q-44.254,0-88.507,0c-3.75,0-5.436,1.68-5.436,5.4q0,26.161,0,52.322c0,3.83,1.663,5.5,5.481,5.5Q3125.841-3022.5,3147.967-3022.5Zm21.288,20.173c-1.22-1.47-2.213-2.767-3.327-3.949a2.465,2.465,0,0,0-1.606-.712q-16.382-.062-32.764-.022c-.392,0-.938-.008-1.151.226-1.26,1.39-2.442,2.849-3.8,4.457Zm-21.362,5.219c3.274,0,6.548-.01,9.822.006.961,0,1.832-.2,1.833-1.323,0-1.157-.932-1.3-1.856-1.3h-19.509c-.934,0-1.849.174-1.833,1.326.017,1.135.907,1.3,1.857,1.3C3141.436-2997.118,3144.665-2997.109,3147.893-2997.109Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopIc);
export default __webpack_public_path__ + "static/media/laptop-ic.6d245cc2e6b84508224cd850cf1dcda8.svg";
export { ForwardRef as ReactComponent };